import CHAOS_ANT_DESIGN_THEME from '@components/theme/Theme';
import { ThemeConfig } from 'antd';
import { mergeDeepLeft } from 'ramda';

// @ts-ignore
export const CHAOS_DASHBOARD_THEME: ThemeConfig = mergeDeepLeft(
  {
    inherit: false,
    components: {
      Tree: {
        controlItemBgHover: 'transparent',
      },
      Form: {
        itemMarginBottom: 0,
      },
      Button: {
        contentFontSize: 14,
        contentFontSizeLG: 14,
        colorText: 'var(--color-text-on-accent)',
        defaultBg: '#FFFFFF',
        defaultBorderColor: 'var(--color-border-primary)',
        defaultColor: 'var(--color-text-secondary)',
        borderRadius: 4,
        defaultShadow: 'none',
        primaryShadow: 'none',
        dangerShadow: 'none',
      },
      Segmented: {
        itemSelectedColor: 'var(--color-text-on-accent)',
      },
      Input: {
        activeShadow: 'none', // remove the blue glow
      },
    },
    token: {
      fontFamily: 'Inter',
      borderRadius: 4,
      fontSize: 14,
      colorBorderSecondary: '#c3c3c3',
      colorError: '#ef6552',
      colorPrimary: '#424242',
      colorLink: '#ef8354',
    },
  },
  CHAOS_ANT_DESIGN_THEME,
);
